import ApiService from "../../core/services/ApiService";

export interface PartnershipOverviewDto {
  entityId: number;
  name: string;
  partnerCount: number;
  calcProfileItemCount: number;
  hasProject: boolean;
  projectId: number | null;
  projectName: string | null;
  projectStatus: string | null;
  completedCalcs: number;
  totalCalcs: number;
  progressPct: number;
}

export interface ClientOverviewDto {
  clientId: string;
  clientName: string;
  taxYear: string;
  totalPartnerships: number;
  totalPartners: number;
  partnerships: PartnershipOverviewDto[];
}

class ClientOverviewService extends ApiService {
  async getClientOverview(clientId: string, taxYear: string): Promise<ClientOverviewDto> {
    return this.makeRequest<ClientOverviewDto>(
      `/api/client/overview?clientId=${clientId}&taxYear=${taxYear}`,
      { extractData: true },
    );
  }
}

export default ClientOverviewService;
